import { memo } from 'react';
import styled, { css } from 'styled-components';

import Checkbox from './common/Checkbox';
import Divider from './common/Divider';
import OrganizationAvatar from './OrganizationAvatar';
import SearchInput from './sidepanel/SearchInput';

import type { Showcase } from '@src/types.ts/story';

type OrganizationSwitcherProps = {
  organizations: Showcase[];
  selectedOrganization: Showcase;
  onSelect: (org: Showcase) => void;
  onSearch: (searchTerm: string) => void;
  initialSearchTerm?: string;
};

function OrganizationSwitcher({
  organizations,
  onSelect,
  onSearch,
  selectedOrganization,
  initialSearchTerm,
}: OrganizationSwitcherProps) {
  const availableOrganizations = organizations.filter(
    org => org.id !== selectedOrganization.id,
  );
  return (
    <OptionList>
      <div onClick={e => e.stopPropagation()}>
        <SearchInput
          iconRight={true}
          placeholder="Search project"
          handleAction={onSearch}
          radius={'4px'}
          width={'155px'} // 185px - 30px of padding
          autoSubmitDelay={500}
          initialValue={initialSearchTerm}
        />
      </div>
      <SelectedOptionItem>
        <Checkbox
          label={''}
          color={'#17c964'}
          borderColor={'#17c964'}
          onClick={() => {}}
          checked={true}
          disabled={false}
          shape="circle"
        />
        <OrganizationAvatar album={selectedOrganization} username={null} />
      </SelectedOptionItem>
      <Divider />
      <OptionListScrollable scrollActive={organizations.length > 5}>
        {availableOrganizations.map(org => (
          <OptionItem key={org.id} onClick={() => onSelect(org)}>
            <OrganizationAvatar album={org} username={null} />
          </OptionItem>
        ))}
        {availableOrganizations.length === 0 && (
          <SearchHint>No projects found</SearchHint>
        )}
      </OptionListScrollable>
    </OptionList>
  );
}

export default memo(OrganizationSwitcher);

const OptionList = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  flex-direction: column;

  .organization-info .album-title {
    font-size: 12px;
    text-align: left;
  }
`;

const OptionListScrollable = styled(OptionList)<{ scrollActive: boolean }>`
  ${props =>
    props.scrollActive &&
    css`
      max-height: 220px; /* item = height: 36px + gap: 8px, total visible = 5 items */
      overflow-y: auto;
    `}
`;

const OptionItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  flex-direction: row-reverse;
  gap: 8px;
  &:hover {
    .organization-info .album-title {
      color: #17c964;
    }
  }
`;

const SelectedOptionItem = styled(OptionItem)`
  .organization-info .album-title {
    color: #17c964;
  }
`;

const SearchHint = styled.div`
  font-size: 12px;
  height: 36px; /* same as OptionItem height */
  align-items: center;
  display: flex;
`;
